export default __webpack_public_path__ + "static/media/settings.bbdfe84e.svg";